import React, {useContext} from 'react';
import Alert from "react-bootstrap/Alert";
import {ErrorContext} from "../../Context/ErrorContext";
import Fade from "react-reveal/Fade"

function ErrorMessage(props){
    const errorContext = useContext(ErrorContext);
    const visible = (errorContext.error && props.where !== "modal") || (errorContext.modalError && props.where === "modal");
    let msg;
    if(props.where === "modal"){
        msg = errorContext.modalError ? errorContext.modalError.msg : "Impossibile completare l'operazione";
    }else{
        msg = errorContext.error ? errorContext.error.msg : "Impossibile completare l'operazione";
    }
    return <Fade bottom collapse opposite when={visible}>
            <Alert className={props.className || ""} variant="danger" onClose={errorContext.unsetError} dismissible>{msg}</Alert>
    </Fade>
}

export default ErrorMessage;